import { MainViewCardModel } from "../../models/MainViewCardModel/MainViewCard.model";

export enum CUSTOM_CARD_TYPES {
    APPOINTMENTS = "wizyty",
    TASKS = "zadania"
}

export interface CustomCardProps {
    key?: string | number;
    card: MainViewCardModel;
    onUpdateSuccess?: () => void;
}
